import { REQUEST, FAILURE, SUCCESS } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  iframeUrl: null,
  iframeUrlIsLoaded: false,
  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_LIQUID_CASHBACK_IFRAME_URL[REQUEST]:
      return { ...state, iframeUrlIsLoaded: false };
    case ActionTypes.GET_LIQUID_CASHBACK_IFRAME_URL[SUCCESS]:
      return {
        ...state,
        iframeUrl: action.data.iframe_url,
        iframeUrlIsLoaded: true,
        error: '',
      };
    case ActionTypes.GET_LIQUID_CASHBACK_IFRAME_URL[FAILURE]:
      return {
        ...state,
        iframeUrl: null,
        iframeUrlIsLoaded: true,
        error: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
